// "Future" = gra jeszcze się nie skończyła (gra w trakcie pozostaje widoczna).
// Filtrujemy po gameDateEnd, spójnie z backendem (finishedAfter: now => gameDateEnd > now).
export function filterFuture<T extends { gameDateEnd: string }>(items: readonly T[]): T[] {
  const now: number = Date.now();
  return items.filter((item: T) => new Date(item.gameDateEnd).getTime() > now);
}
